type DeleteResult = {
  data?: { delete_user?: { id: string } | null } | null;
  error?: unknown;
};

type DeleteFailure = { id: string; error: unknown };

export const deleteUsersPreservingHistory = async (
  ids: string[],
  deleteUser: (id: string) => Promise<DeleteResult>,
  refresh: () => Promise<unknown>,
) => {
  const failures: DeleteFailure[] = [];
  for (const id of ids) {
    try {
      const result = await deleteUser(id);
      if (result.error != null) {
        failures.push({ id, error: result.error });
      } else if (result.data?.delete_user?.id !== id) {
        failures.push({
          id,
          error: new Error('delete_user did not return the deleted user'),
        });
      }
    } catch (error) {
      failures.push({ id, error });
    }
  }

  let refreshError: unknown = null;
  let refreshFailed = false;
  try {
    await refresh();
  } catch (error) {
    refreshError = error;
    refreshFailed = true;
  }
  return {
    failedIds: failures.map(failure => failure.id),
    failures,
    refreshFailed,
    refreshError,
  };
};
